module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x160-ee564d90bfb16893b8cbfed86a500f2c.webp";